export default {
    page_title: "Ventas",
    confirm_delete: {
        title: "Eliminar ventas",
        body_singular: "Eliminar la venta de la base de datos es una acción irreversible.",
        body_plural: "Eliminar las ventas de la base de datos es una acción irreversible.",
        warning: "Esta exclusión es permanente.",
        inconsistency_singular: "Eliminar la venta puede causar inconsistencias en los informes de Kevi, que ya no reflejarán los mismos números que el ERP.",
        inconsistency_plural: "Eliminar las ventas puede causar inconsistencias en los informes de Kevi, que ya no reflejarán los mismos números que el ERP.",
        instruction: "Para confirmar, escribe la frase a continuación:",
        phrase_singular: "ELIMINAR {0} VENTA PERMANENTEMENTE",
        phrase_plural: "ELIMINAR {0} VENTAS PERMANENTEMENTE",
        button: "Eliminar",
    },
    more_actions: "Más acciones",
    remove_all: "Eliminar todos",
    export: "Exportar",
    table: {
        id: "ID",
        date: "Fecha",
        status: "Estado",
        value: "Valor",
        client: "Cliente",
        phone: "Teléfono",
        email: "Correo electrónico",
    },
    filters: {
        client_segment: "Segmento del cliente",
        order_status: "Estado del Pedido",
    },
    export_headers: {
        id: "Id",
        date: "Fecha",
        status: "Estado",
        value: "Valor",
        client: "Cliente",
        phone: "Teléfono",
        email: "Correo electrónico",
        external_id: "Id Externo",
    },
    deleted_success: "Pedidos eliminados",
    select_all: "Seleccionar todos",
    unselect_all: "Desmarcar todos",
    selection: {
        count: "{$0} seleccionado{$1}",
        export: "Exportar seleccionados",
        remove: "Eliminar seleccionados",
    },
    export_selected_success: "{$0} pedido{$1} exportado{$2}",
    delete_selected_success: "{$0} pedido{$1} eliminado{$2}",
};
